import { Button as CommonButton } from "common/pixi/button";
import { cancel, delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
export class Button extends CommonButton {
    constructor(pixiContext, sheets) {
        const textures = Sheets.animationTextures(sheets, fileName);
        const hitArea = {
            x: 243,
            y: 983,
            w: 218,
            h: 103,
        };
        super({
            pixiContext,
            textures,
            hitArea,
            hideButtonWhenclick: false,
        });
    }
    animate() {
        return cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[0];
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[1];
            }
        });
    }
}
export const fileName = "button";
//# sourceMappingURL=button.js.map